// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Z6H3Z","spin":"Spinner_spin__Q9zsz"};